import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../components/AccountContext';
import SuperlinkList from './SuperlinkList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query superLinks(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SuperLinkFilter
    $sort: SuperLinkSortSpecifier
  ) {
    account(id: $accountId) {
      id
      superLinks(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        totalCount
        indexFrom
        indexTo
        edges {
          cursor
          node {
            id
            name
            totalAssessment
            totalFinalStateAssessment
            createdOn
            createdBy{
              id
              firstName
              lastName
            }
            assessmentTemplate {
              id
              title
            }
          }
        }
      }
    }
  }
`;

class SuperLinkListContainer extends Component {
  render() {
    const { currentAccount, location } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.superLinks : emptyConnection();

          return <SuperlinkList connection={connection} currentAccount={currentAccount} loading={loading} />;
        }}
      </Query>
    );
  }
}

SuperLinkListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(SuperLinkListContainer)));
